export default __webpack_public_path__ + "static/tech-3fde19b6abf5d052e0de744f62c03db7.png";